/* This is the emis financial components */
<template>
  <v-container>
    <div>
      <span v-html="title + ' ' + fiscalYear"></span>
    </div>
    <div>
      <table style="height: 79px" width="800" border="1px;" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 490px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ប្រភេទ
            </td>
            <td
              style="
                width: 300px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ទទួលជាប្រាក់រៀល
            </td>
          </tr>
          <tr v-for="(value, row) in financial.length" :key="row">
            <td
              v-if="row < 2"
              style="
                width: 490px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ financial[row] + " " + fiscalYear }}
            </td>
            <td v-else>
              {{ financial[row] }}
            </td>
            <td
              style="
                width: 300px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[row].dt[0]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { financial } from "@/utils/ascf/commonConfig.js";
export default {
  props: ["data", "title", "lst_acc"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      financial: financial,
    };
  },
  computed: {
    fiscalYear: function () {
      return this.lst_acc.substring(5, 9);
    },
  },
};
</script>

<style scoped>
/*@import './assets/styles/ascfstyle.css';*/
.number {
  width: 300px;
  text-align: center;
}
</style>